<div id="gatewaySync-main-wraper">
  <div class="col-12 search-ft p-0 mt-3">
    <div class="row">
      <div class="col d-flex align-items-start p-0">
        <div class="form-group p-2 ml-2">
            <select name="ddfilter" class="form-control" (change)="gatewayFilterSelectChanged($event)">
                <option *ngFor="let type of gatewayFilter" [value]="type.id"
                    [selected]="type.id === gatewayFilterSelectedId">
                    {{ type.name }}
                </option>
            </select> 
            </div>
          <div class="form-group p-2">
            <input type="text" class="form-control" name="txtGWSrchUnit" [(ngModel)]="txtGWSrchUnit" maxlength="64"
            tabindex="1" (keydown.enter)="onKeyEnter()" (keypress)="clearMacAddress()" />            
        </div>
        <div class="form-group p-2" *ngIf="hasMultipleMac">
            <select name="ddMacAddress" class="form-control" (change)="gatewaymacSelectChanged($event)"
              [(ngModel)]="selGatewayMacAddress">
            <option *ngFor="let type of unitMacAddresses" [selected]="type.id === selGatewayMacAddress">
                {{type}}
            </option>
            </select>          
        </div>
        <div class="col d-flex align-items-start  btnAlign">
        <div class="form-group">
          <button class="btn btn-primary mr-2" name="btnGWSearch" (click)="getGatewayInfoByFilterSearch()" tabindex="2">
            Search
          </button>
          <button class="btn btn-outline-primary mr-2" name="btnGWReset" (click)="resetFilters()" tabindex="3">
            Reset
          </button>              
        </div>
      </div>  
      </div> 
  </div>
</div>
<div #gridSection class="gateway-sync-data-container">
  
    <div class="col d-flex align-items-center p-0">
      <div class="form-group buttonAlignments mb-0">  
        <input type="checkbox" class="cuscheckbox" name="checkUnit1" [(ngModel)]="chkUnit1" [disabled]="DisableMobilineDev">&nbsp;
        <label name="lblGWUnitNum1" class="control-label mb-0">Unit Number:&nbsp;</label>{{unitnNumber1}}
      </div>
    <img src="../assets/images/info.png" class="imgSize imgAlign" *ngIf="DisableMobilineDev">&nbsp;
    <label id="lblmessage" class="mmslblalign control-label infoTextColor" *ngIf="DisableMobilineDev">Gateway Sync is currently not enabled for Otis Mobiline devices</label>
    <div class="ml-auto com-btn-test">
      <button class="btn btn-sync-primary mr-2" name="btnG3MSSync" [disabled]="DisableMobilineDev || !isSyncEnabled" tabindex="2" (click)="open(SyncGatewayInfoModal,false)">
        <em class="fas fa-sync-alt"></em> DIGI & G3MS Sync
      </button>
      <button class="btn btn-sync-outline" name="btnDigiSync" [disabled]="DisableMobilineDev || !isSyncEnabled" tabindex="2" (click)="open(SyncGatewayInfoModal,true)">
        <em class="fas fa-sync-alt"></em> G3MS Sync
      </button>
    </div>
    </div>
    <ag-grid-angular [enableCellTextSelection]="true" class="ag-theme-material mt-2 gateway-layout" [rowData]="rowDataUnit1"
      [columnDefs]="columnDefs" [gridOptions]="gridOptions">
    </ag-grid-angular>
    <input *ngIf="lblDisplayU2" type="checkbox" class="cuscheckbox" name="checkUnit2" [(ngModel)]="chkUnit2" [disabled]="DisableMobilineDev">&nbsp;
    <label *ngIf="lblDisplayU2" name="lblGWUnitNum1" class="control-label">Unit Number:&nbsp;</label>{{unitnNumber2}}
    <ag-grid-angular *ngIf="lblDisplayU2" [enableCellTextSelection]="true" class="ag-theme-material mt-2 gateway-layout" [rowData]="rowDataUnit2"
      [columnDefs]="columnDefs" [gridOptions]="gridOptions">
    </ag-grid-angular>
    <input *ngIf="lblDisplayU3" type="checkbox" class="cuscheckbox" name="checkUnit3" [(ngModel)]="chkUnit3" [disabled]="DisableMobilineDev">&nbsp;
    <label *ngIf="lblDisplayU3" name="lblGWUnitNum1" class="control-label">Unit Number:&nbsp;</label>{{unitnNumber3}}
    <ag-grid-angular *ngIf="lblDisplayU3" [enableCellTextSelection]="true" class="ag-theme-material mt-2 gateway-layout" [rowData]="rowDataUnit3"
      [columnDefs]="columnDefs" [gridOptions]="gridOptions">
    </ag-grid-angular>
    <input *ngIf="lblDisplayU4" type="checkbox" class="cuscheckbox" name="checkUnit4" [(ngModel)]="chkUnit4" [disabled]="DisableMobilineDev">&nbsp;
    <label *ngIf="lblDisplayU4" name="lblGWUnitNum1" class="control-label">Unit Number:&nbsp;</label>{{unitnNumber4}}
    <ag-grid-angular *ngIf="lblDisplayU4" [enableCellTextSelection]="true" class="ag-theme-material mt-2 gateway-layout" [rowData]="rowDataUnit4"
      [columnDefs]="columnDefs" [gridOptions]="gridOptions">
    </ag-grid-angular>
    </div>
</div>

<ng-template #SyncGatewayInfoModal let-modal>  
  <div id="syncUnit" class="modal-body eloUpdateStyle">
    <div class="col-12 search-ft p-2 mt-3">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label class="lblInfo">Are you sure you want to sync Gateway details for the Unit: {{ selUnitNumbers }} ..?</label> 
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex align-items-center flex-column">
          <div class="col d-flex ng-star-inserted justify-content-center mb-3" *ngIf="!isG3MSSync">
              <label name="lblGWPwd" class="control-label lblws p-2">Gateway Password </label>
              <input type="password" class="form-control txtWidth" name="txtGWPwd" [(ngModel)]="txtGWPwd" maxlength="20" />          
          </div>
          <div class="col-6 mx-auto d-flex justify-content-center btnPoupAlign">
            <button type="button" class="btn btn-primary mr-2 btnwidth" (click)="UpdateGatewayInfo()">Yes</button>
            <button type="button" id="btnClose" class="btn btn-outline-primary mr-2 btnwidth" (click)="modal.close()">No</button>
          </div>
        </div>
      </div>
    </div>
  </div>  
</ng-template>